// import { useState } from "react";
import { Button, Menu } from "antd";
import { FC } from "react";
import { NavLink, useLocation } from "react-router-dom";
import logo from "assets/images/logoSvg.svg";
import { menuList } from "./menuList";
import { useAppDispatch, useAppSelector } from "store";
import { sigOut } from "store/slices/authSlice";

interface SidenavProps {
  color?: string;
}

const Sidenav: FC<SidenavProps> = () => {
  const { pathname } = useLocation();
  const page = pathname.replace("/", "");
  const { contact } = useAppSelector((state) => state.auth);

  const dispatch = useAppDispatch();

  return (
    <>
      <div className="brand">
        <img src={contact?.image_url} alt="" height={70} />
        <span>{ contact?.name }</span>
      </div>
      <hr />
      <Menu theme="light" mode="inline" defaultSelectedKeys={["1"]}   >
        {menuList.map((menu) => (
          <Menu.Item key={menu.key}  >
            <NavLink to={menu.path} >
              <span
                className="icon"
                style={{
                  background: page === `${menu.path}` ? "" : "",
                }}
              >
                {menu.icon}
              </span>
              <span className="label" style={{}}>
                {menu.title}
              </span>
            </NavLink>
          </Menu.Item>
        ))}
      </Menu>
      {/* <Button
        onClick={() => {
          dispatch(sigOut());
        }}
        style={{ marginTop: 30, marginLeft: 15 }}
        type="primary"
        className="btn-logout"
      >
        <span className="icon">{<i className="fas fa-sign-out-alt"></i>}</span>
         ออกจากระบบ
      </Button> */}
    </>
  );
};

export default Sidenav;
